// extracted by mini-css-extract-plugin
export default {"root":"SearchInput_root__0JYZx"};